import React, { useState, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { TextField } from "@material-ui/core";

const ModalCreate = ({
  isOpen,
  toggle,
  title,
  formId,
  token,
  infoModal,
  updateTable,
  numeroCaso,
}) => {
  const [numeroValidacion, setNumeroValidacion] = useState("");
  const [fechaFactura, setFechaFactura] = useState("");
  const [numeroFactura, setNumeroFactura] = useState("");
  const modalRef = useRef(null);

  console.log(formId, "id form");
  const [, setState] = React.useState({
    jason: false,
  });

  const handleNumeroValidacion = (event) => {
    setNumeroValidacion(event.target.value);
  };

  const handleNumeroFactura = (event) => {
    setNumeroFactura(event.target.value);
  };

  const handleCreateSubmit = (event) => {
    event.preventDefault();
    axios
      .post(
        `formulario/facturacion/${formId}`,
        {
          NumeroFactura: numeroFactura,
          NumeroValidacion: numeroValidacion,
          FechaFactura: fechaFactura,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Creado!",
          text: "se asocio la factura con exito",
          showCloseButton: true,
        }).then(() => {
          toggle();
          updateTable();
          setNumeroFactura("");
          setNumeroValidacion("");
          setFechaFactura("");
          setState({ jason: false });
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Ha ocurrido un error al asociar la factura.",
          showCloseButton: true,
        }).then(() => {
          toggle();
          setNumeroFactura("");
          setNumeroValidacion("");
          setFechaFactura("");
          setState({ jason: false });
        });
      });
  };

  return (
    <Modal ref={modalRef} isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <TextField
            label="Numero de caso"
            className="form-control "
            type="text"
            name="numeroFactura"
            value={numeroCaso}
            isdisable
          />
        </FormGroup>
        <FormGroup>
          <TextField
            label="Numero de factura"
            className="form-control "
            type="text"
            name="numeroFactura"
            value={numeroFactura}
            onChange={handleNumeroFactura}
          />
        </FormGroup>
        <FormGroup>
          <label>Fecha Factura:</label>
          <input
            className="form-control"
            name="fechaFactura"
            type="date"
            onChange={(event) => setFechaFactura(event.target.value)}
            value={fechaFactura}
          />
        </FormGroup>
        <FormGroup>
          <TextField
            label="Numero de validación"
            className="form-control "
            type="text"
            name="numeroValidacion"
            value={numeroValidacion}
            onChange={handleNumeroValidacion}
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <Button onClick={handleCreateSubmit} color="primary" otype="submit">
          Insertar
        </Button>
        <Button color="danger" onClick={() => toggle()}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalCreate;
